// The schema.org graph the pages publish, in the shape WordPress (Yoast) used
// to render. Keeping it means the structured data Google already indexed does
// not change when a page moves from WordPress to this app.

const SITE = 'https://japoniacars.pl'
const NAME = 'Japonia Cars'

const url = (path = '/') => SITE + path

const organization = () => ({
  '@type': 'Organization',
  '@id': url('/#organization'),
  name: NAME,
  url: url('/'),
  logo: {
    '@type': 'ImageObject',
    inLanguage: 'pl-PL',
    '@id': url('/#/schema/logo/image/'),
    url: url('/media/logo.svg'),
    contentUrl: url('/media/logo.svg'),
    caption: NAME,
  },
  image: { '@id': url('/#/schema/logo/image/') },
})

const website = () => ({
  '@type': 'WebSite',
  '@id': url('/#website'),
  url: url('/'),
  name: NAME,
  description: '',
  publisher: { '@id': url('/#organization') },
  inLanguage: 'pl-PL',
})

const breadcrumbList = (path, trail) => ({
  '@type': 'BreadcrumbList',
  '@id': url(path) + '#breadcrumb',
  itemListElement: [
    { '@type': 'ListItem', position: 1, name: 'Strona główna', item: url('/') },
    ...trail.map((crumb, i) => ({
      '@type': 'ListItem',
      position: i + 2,
      name: crumb.name,
      ...(crumb.path ? { item: url(crumb.path) } : {}),
    })),
  ],
})

/**
 * One page of the site.
 *
 * @param {object} page
 * @param {string} page.path      e.g. '/aukcje/'
 * @param {string} page.name      the <title> without the site suffix
 * @param {string} [page.image]   primary image, site-root-relative
 * @param {object[]} [page.breadcrumbs]  [{ name, path? }], home is implied
 * @param {string} [page.published]  ISO date
 * @param {string} [page.modified]   ISO date
 */
export function pageSchema({ path, name, image, breadcrumbs = [], published, modified }) {
  const page = {
    '@type': 'WebPage',
    '@id': url(path),
    url: url(path),
    name: `${name} - ${NAME}`,
    isPartOf: { '@id': url('/#website') },
    ...(image
      ? {
          primaryImageOfPage: { '@id': url(path) + '#primaryimage' },
          image: { '@id': url(path) + '#primaryimage' },
          thumbnailUrl: url(image),
        }
      : {}),
    ...(published ? { datePublished: published } : {}),
    ...(modified ? { dateModified: modified } : {}),
    breadcrumb: { '@id': url(path) + '#breadcrumb' },
    inLanguage: 'pl-PL',
    potentialAction: [{ '@type': 'ReadAction', target: [url(path)] }],
  }

  const graph = [page]

  if (image) {
    graph.push({
      '@type': 'ImageObject',
      inLanguage: 'pl-PL',
      '@id': url(path) + '#primaryimage',
      url: url(image),
      contentUrl: url(image),
    })
  }

  graph.push(breadcrumbList(path, breadcrumbs), website(), organization())

  return { '@context': 'https://schema.org', '@graph': graph }
}
